import React from 'react';

const LodgingsLoadMoreButton = ({ onClick }) => (
  <div className="load-more-container text-center mt-4">
    <button
      onClick={onClick}
      className="btn-secondary inline-block"
    >
      Load more
    </button>
  </div>
);

export default LodgingsLoadMoreButton;

